<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateTimeoffJournal"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-auto w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed overflow-y-auto max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky z-50 top-0 border-b-1.5 p-3"
          >
            <p class="text-base">{{title}}</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              alt=""
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Type</label>

              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.Type"
                :default-first-item="true"
                @change="(value) => (info.Type = value)"
                placeholder="Enter a Type"
              >
                <el-option
                  v-for="leaveType in types"
                  :key="leaveType"
                  :label="leaveType"
                  :value="leaveType"
                >
                </el-option>
              </el-select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Employee Name</label>

              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.Fullname"
                :default-first-item="true"
                @change="findEmployee"
                placeholder="Enter a country"
              >
                <el-option
                  v-for="employee in employees"
                  :key="employee.Id"
                  :label="`${employee.EmployeeNo} - ${decryptionDataLocal(
                    employee.Fullname,
                    decryptionKey
                  )}`"
                  :value="employee.Id"
                >
                  {{
                    employee.EmployeeNo +
                    " - " +
                    decryptionDataLocal(employee.Fullname, decryptionKey)
                  }}
                </el-option>
              </el-select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Leave Type Name</label>

              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.LeaveTypeName"
                :default-first-item="true"
                @change="findLeaveType"
                placeholder="Enter a Leave Type"
              >
                <el-option
                  v-for="leaveType in leaveTypes"
                  :key="leaveType.Name"
                  :label="leaveType.Name"
                  :value="leaveType.Name"
                >
                </el-option>
              </el-select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Leave Period Name</label>
              <el-autocomplete
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.LeavePeriodName"
                :fetch-suggestions="fetchLeavePeriods"
                @focus="fetchLeavePeriods"
                :default-first-item="true"
                @select="findLeavePeriod"
                placeholder="Enter a Leave Period Name"
                value-key="PeriodName"
              >
                <template slot-scope="{ item }"
                  >{{ item.PeriodName }} ({{
                    momentLocal(item.StartingDate).format("DD/MM/YY") +
                    " to " +
                    momentLocal(item.EndingDate).format("DD/MM/YY")
                  }})</template
                >
              </el-autocomplete>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                v-model="info.StartDate"
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">End Date</label>
              <input
                v-model="info.EndDate"
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
                :min="new Date(info.StartDate).toISOString().split('T')[0]"
              />
            </div>

            <!-- <div class="text-sm">
              <label class="block pb-1">Days to Subtract</label>
              <input
                v-model="info.Days"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div> -->
            <div class="text-sm" v-if="info.Type">
              <label class="block pb-1">{{ daysLabel }}</label>
              <input
                v-model="info.Days"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";
import moment from "moment";

export default {
  name: "CompanySetupCreateLocation",
  props: ["showCreateTimeoffJournal", "reload", "title"],
  components: { Loader },
  data() {
    return {
      saved_departments: [],
      country: null,
      decryptionDataLocal: "",
      decryptionKey: "",
      momentLocal: "",
      info: {
        TimeoffJournalId: "string",
        Type: "",
        Fullname: "",
        LeaveTypeName: "",
        LeavePeriodName: "",
        Days: 0,
        EmployeeId: "",
        LeaveTypeId: "",
        LeavePeriodId: "",
        StartDate: new Date(),
        EndDate: new Date(),
      },
      leavePeriodToSelect: "",
      leaveTypeToSelect: "",
      employeeToSelect: "",
      create_error: null,
      create_success: null,
      loading: false,
      periods: [],
      leaveTypes: [],
      employees: [],
      publicHolidays:[],
      types: [
        "Take On",
        "Negative Adjustment",
        "Positive Adjustment",
        "Brought Forward",
      ],
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentJournalId"]),

    daysLabel() {
      if (this.info.Type === "Brought Forward") {
        return "Days to Carry Forward";
      } else if (this.info.Type === "Positive Adjustment") {
        return "Days to Add";
      } else if (this.info.Type === "Negative Adjustment") {
        return "Days to Subtract";
      } else {
        return "Days"; // Default label if no type is selected
      }
    },

    // Calculate the number of days between the start and end dates
    // only if both fields are filled

  },
  watch: {
    "info.StartDate": function () {
      this.daysBetweenDates();
    },
    "info.EndDate": function () {
      this.daysBetweenDates();
    },
  },
  created() {
    this.getPeriods();
    this.getLeaveTypes();
    this.getEmployees();
    this.decryptionKey = this.$decryptionKey;
    this.decryptionDataLocal = decryptData;
    this.momentLocal = moment;
    this.getPublicHolidays()
  },
  methods: {
    getPublicHolidays(){
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
          .get(
              `${this.getOrganization}/holiday/${this.$ApiVersion}/request`,
              options
          ).then((response)=>{
            this.publicHolidays = response.data.Data
      }).catch((error)=>{
            console.log(error)
      })
    },
    async daysBetweenDates() {
      if (this.info.StartDate && this.info.EndDate) {
        const startDate = new Date(this.info.StartDate);
        const endDate = new Date(this.info.EndDate);
        if (startDate > endDate) {
          return "";
        }
        let currentDate = new Date(startDate);
        let weekdayCount = 0;
        while (currentDate <= endDate) {
          const dayOfWeek = currentDate.getDay(); // 0 for Sunday, 6 for Saturday
          const formattedDate = currentDate.toISOString().split("T")[0]; // Format to YYYY-MM-DD
          if (
              dayOfWeek !== 0 &&
              dayOfWeek !== 6 &&
              !this.publicHolidays.some((holiday) => holiday.ISO.startsWith(formattedDate))
          ) {
            weekdayCount++;
          }

          currentDate.setDate(currentDate.getDate() + 1);
        }
        this.info.Days = weekdayCount;
        console.log(this.info.Days);
      } else {
        this.info.Days = 0;
      }
      return "";
    },
    close() {
      this.$emit("close");
    },

    async fetchLeavePeriods(queryString, callback) {
      //console.log(this.leavePeriodToSelect)
      console.log(typeof queryString);
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (typeof queryString === "string" && queryString) {
        queryString = queryString.split(" ")[0];
        //console.log(queryString)
        this.leavePeriodToSelect = this.periods.filter((period) =>
          period.PeriodName.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.leavePeriodToSelect.length) {
          callback([{ PeriodName: "No results found" }]);
          return;
        }
        callback(this.periods);
      } else {
        callback(this.periods);
      }
    },

    findLeavePeriod(leavePeriod) {
      this.info.LeavePeriodId = leavePeriod.Id;
      this.info = {
        ...this.info,
        LeavePeriodName: `${leavePeriod.PeriodName} (${moment(
          leavePeriod.StartingDate
        ).format("DD/MM/YY")} to ${moment(leavePeriod.EndingDate).format(
          "DD/MM/YY"
        )})`,
      };
    },

    async fetchLeaveTypes(queryString, callback) {
      if (queryString) {
        this.leaveTypeToSelect = this.leaveTypes.filter((leave) =>
          leave.Name.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.leaveTypeToSelect.length) {
          callback([{ Name: "No results found" }]);
          return;
        }
        callback(this.leaveTypeToSelect);
      } else {
        callback(this.leaveTypes);
      }
    },

    async fetchTypes(queryString, callback) {
      if (queryString) {
        this.typeToSelect = this.types.filter((type) =>
          type.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.info.Type.length) {
          callback(["No results found"]);
          return;
        }
        callback(this.typeToSelect);
      } else {
        callback(this.types);
      }
    },

    findLeaveType(leaveTypeName) {
      this.info.LeaveTypeId = this.leaveTypes.find(
        (type) => type.Name === leaveTypeName
      ).Id;
    },
    async fetchEmployees(queryString, callback) {
      if (queryString) {
        this.employeeToSelect = this.employees.filter((employee) =>
          employee.Fullname.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.employeeToSelect.length) {
          callback([{ Fullname: "No results found" }]);
          return;
        }
        callback(this.employeeToSelect);
      } else {
        callback(this.employees);
      }
    },

    findEmployee(employeeId) {
      this.info.EmployeeId = employeeId;
    },
    setCountryName(country) {
      this.info.Country = country.Name;
    },
    create() {
      this.info.Type = this.info.Type.split(" ").join("");
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.info.TimeoffJournalId = this.getCurrentJournalId.TimeoffJournalId;
      this.info.Days = +this.info.Days;
      axios
        .post(
          `${this.getOrganization}/timeoff/journal/line/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.info = {
                TimeoffJournalId: "string",
                Type: "",
                Fullname: "",
                LeaveTypeName: "",
                LeavePeriodName: "",
                Days: 0,
                EmployeeId: "",
                LeaveTypeId: "",
                LeavePeriodId: "",
                StartDate: new Date(),
                EndDate: new Date(),
              };
              setTimeout(() => {
                this.create_success = null;
                this.reload();
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2500);
          }
        );
    },
    // /{organization}/setup/leave/period/v1/request
    getPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leave/period/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.periods = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.leaveTypes = response.data.Data.map((row) => {
                return { ...row, showActions: false };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.employees = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
